var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5,2c-1.93,0-3.5,1.57-3.5,3.5,0,.6,.17,1.16,.43,1.65L7.15,15.43c-.49-.27-1.05-.43-1.65-.43-1.93,0-3.5,1.57-3.5,3.5s1.57,3.5,3.5,3.5,3.5-1.57,3.5-3.5c0-.6-.17-1.16-.43-1.65l8.28-8.28c.49,.27,1.05,.43,1.65,.43,1.93,0,3.5-1.57,3.5-3.5s-1.57-3.5-3.5-3.5ZM5.5,20c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5,1.5,.67,1.5,1.5-.67,1.5-1.5,1.5ZM18.5,7c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5,1.5,.67,1.5,1.5-.67,1.5-1.5,1.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLine);
export default __webpack_public_path__ + "static/1770312069/media/icon-line.b7ab2165a53509b42023ba716b489e5e.svg";
export { ForwardRef as ReactComponent };